// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help_section div > span:first-child {
  color: #ff3d71;
  min-width: 120px;
  max-width: 220px;
  font-size: 0.7rem;
  margin: 4px 15px;
}

.help_section div > span:last-child {
  color: #3d98ff;
  font-size: 0.78rem;
}

.headerkey {
  color: #000 !important;
  margin: 6px 16px !important;
  font-size: 0.8rem !important;
}

.tool_container {
  min-width: 310px;
  width: 100%;
  text-align: left;
  padding: 0px;
  display: flex;
}

.info {
  font-size: 0.75rem;
  padding: 2px 5px;
}

.jsonValue {
  background: #fff;
  height: 18px;
  font-size: 0.8rem;
  margin: 0px 8px;
  line-height: 0;
  color: #222b45;
  border: 0;
  padding: 0.175rem 0.175rem !important;
  vertical-align: middle;
  width: 200px;
}

.jsonValue:focus {
  padding-right: 5px;
  /*background-color: #f7f9fc;*/
  /*border-color: #e4e9f2;*/
  color: #222b45;
  /*padding: 0.65rem 0.5rem !important;*/
  box-shadow: 0px 5px 5px rgba(51, 102, 255, 0.2);
  border-color: #36f;
  background-color: #fff;
  border: 1px solid #36f;
  margin: 0px 8px;
  width: 200px;
}

.jsonValueTextarea {
  font-size: 0.78rem;
}

.w240 {
  width: 240px !important;
}

.w160 {
  width: 160px !important;
}

.w200 {
  width: 200px !important;
}

.w100 {
  width: 100px !important;
}

.w180 {
  width: 180px !important;
}

.w50 {
  width: 50px !important;
}

.sign {
  cursor: pointer;
}

.wc-100 {
  width: 100%;
}

.w40 {
  width: 40px !important;
}

.w120 {
  width: 120px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/json-tree-editor-item/json-tree-editor-item.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AACA;EACE,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,sBAAA;EACA,2BAAA;EACA,4BAAA;AAEF;;AACA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,SAAA;EACA,qCAAA;EACA,sBAAA;EACA,YAAA;AAEF;;AAGA;EACE,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAAA;EACA,sCAAA;EACA,+CAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAEA;EACE,uBAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AAAA;EACE,sBAAA;AAGF;;AAAA;EACE,uBAAA;AAGF","sourcesContent":[".help_section div > span:first-child {\r\n  color: #ff3d71;\r\n  min-width: 120px;\r\n  max-width: 220px;\r\n  font-size: 0.7rem;\r\n  margin: 4px 15px;\r\n}\r\n.help_section div > span:last-child {\r\n  color: #3d98ff;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.headerkey {\r\n  color: #000 !important;\r\n  margin: 6px 16px !important;\r\n  font-size: 0.8rem !important;\r\n}\r\n\r\n.tool_container {\r\n  min-width: 310px;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 0px;\r\n  display: flex;\r\n}\r\n\r\n.info {\r\n  font-size: 0.75rem;\r\n  padding: 2px 5px;\r\n}\r\n\r\n.jsonValue {\r\n  background: #fff;\r\n  height: 18px;\r\n  font-size: 0.8rem;\r\n  margin: 0px 8px;\r\n  line-height: 0;\r\n  color: #222b45;\r\n  border: 0;\r\n  padding: 0.175rem 0.175rem !important;\r\n  vertical-align: middle;\r\n  width: 200px;\r\n  // min-width: 160px;\r\n  // width: 235px;\r\n  // max-width: 240px;\r\n}\r\n.jsonValue:focus {\r\n  padding-right: 5px;\r\n  /*background-color: #f7f9fc;*/\r\n  /*border-color: #e4e9f2;*/\r\n  color: #222b45;\r\n  /*padding: 0.65rem 0.5rem !important;*/\r\n  box-shadow: 0px 5px 5px rgb(51 102 255 / 20%);\r\n  border-color: #36f;\r\n  background-color: #fff;\r\n  border: 1px solid #36f;\r\n  margin: 0px 8px;\r\n  width: 200px;\r\n}\r\n\r\n.jsonValueTextarea {\r\n  font-size: 0.78rem;\r\n}\r\n.w240 {\r\n  width: 240px !important;\r\n}\r\n.w160 {\r\n  width: 160px !important;\r\n}\r\n\r\n.w200 {\r\n  width: 200px !important;\r\n}\r\n\r\n.w100 {\r\n  width: 100px !important;\r\n}\r\n\r\n.w180 {\r\n  width: 180px !important;\r\n}\r\n\r\n.w50 {\r\n  width: 50px !important;\r\n}\r\n\r\n.sign {\r\n  cursor: pointer;\r\n}\r\n\r\n.wc-100 {\r\n  width: 100%;\r\n}\r\n.w40 {\r\n  width: 40px !important;\r\n}\r\n\r\n.w120 {\r\n  width: 120px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
